import React from 'react'
import { ENTITY } from '../../data/entityData'

export const ServiceChunkBlock = ({
  serviceIds,
  headingOverride
}) => {
  const items = ENTITY.services.filter(
    s => serviceIds.includes(s.id)
  )
  if (!items.length) return null

  const heading = headingOverride ||
    `Services offered by ${ENTITY.name} in ` +
    `${ENTITY.address.addressLocality}, Ethiopia`

  return (
    <section
      aria-label={heading}
      className="py-12 px-6"
      style={{ background: 'var(--bg-deep, #0a0a0a)' }}
    >
      <div className="max-w-[860px] mx-auto">
        <h2 className="text-xl mb-8 opacity-50 font-mono" style={{ color: '#C9A84C' }}>
          {heading}
        </h2>
        <div className="space-y-8" style={{ display: 'grid', gap: '32px' }}>
          {items.map(item => (
            <article
              key={item.id}
              itemScope
              itemType="https://schema.org/Service"
              className="border-t pt-6"
              style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '24px' }}
            >
              <h3
                itemProp="name"
                className="font-semibold text-lg mb-2"
                style={{ color: '#FBF8F0', fontFamily: 'Inter', fontSize: '18px', marginBottom: '8px' }}
              >
                {item.name}
              </h3>
              <p
                itemProp="description"
                className="text-base leading-relaxed opacity-60"
                style={{ color: '#FBF8F0', fontFamily: 'Inter', marginBottom: '8px' }}
              >
                {item.description}
              </p>
              <p
                itemProp="areaServed"
                className="mt-2 text-xs font-mono opacity-40"
                style={{ color: '#C9A84C' }}
              >
                {item.areaServed}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
